<template>
    <div class="form-group">
        <div class="fg-select">
            <ul class="fg-select__options">
                <li class="fg-option">
                    <select :id="id" :class="{ 'is-selected': isChecked }" v-model="localChecked" @change="updateSelectedOptions()">
			<option v-for="(option, index) in options" :key="index" :value="index">
                            <span class="fg-option__label">{{ getNom(index, options) }}</span>
                        </option>
                    </select>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "fg-select",
        props: {
            id: {
                type: String,
                required: true,
            },
            options: {
                type: Object,
                required: true,
            },
            selectedOptions: {
                type: Array,
                default: () => [],
            },
        },
        computed: {
            isChecked() {
                return this.localChecked;
            }
        },
        data() {
            return {
                localChecked: this.selectedOptions.includes(this.id)
            };
        },
        methods: {
            getNom(index, options) {
                return options[index].nom
            },
            updateSelectedOptions() {
                this.$emit("update:selectedOptions", [...this.id, this.localChecked]);
            },
        },
    };
</script>

<style>
    li {
	list-style-type: none;
	margin: auto;
	text-align: center;
    }

    ul {
	text-align: center;
	display: inline-block;
	margin: 0px;
	padding: 0px;
    }

    select {
	border: 1px solid #FF8B00;
	border-radius: 40px;
	padding: 7px;
	padding-left: 14px;
	padding-right: 14px;
    }
</style>

